import { AppState } from "../../../redux-configuration/AppState";

export const editMunicipalServiceLoadingSelector = (appState: AppState): boolean => appState.municipality.editService.loading
export const editMunicipalServiceErrorSelector = (appState: AppState): string | undefined => appState.municipality.editService.error
